import React, { useState, useCallback } from 'react';
import { ViewListingAboutLocationWrapper, ViewListingAboutLocationTitle, ViewListingAboutLocationSubtitle, ViewListingMapWrapper, ViewListingLocationVerification, ViewListingLocationVerificationIcon } from "../viewListingStyling";
import CloudMap from "../../../components/map/CloudMap";
import { useMediaQuery } from 'react-responsive';
import CustomZoomControls from '../components/CustomZoomControls';
import MapPopupButton from '../components/MapPopupButton';
import ViewListingMapPopup from '../popups/viewListingMapPopup';
import { ListingInterface } from "../viewListing";

export default function ViewListingAboutLocation({ hasReviews, listing, lat, lng }: { hasReviews: boolean; listing: ListingInterface; lat: number; lng: number }) {
    const isDesktop = useMediaQuery({ minWidth: 768 });
    const [mapInstance, setMapInstance] = useState<google.maps.Map | null>(null);
    const [isMapPopupOpen, setIsMapPopupOpen] = useState(false);

    const handleMapLoad = useCallback((map: google.maps.Map) => {
        setMapInstance(map);
    }, []);

    const handleZoomIn = useCallback(() => {
        if (mapInstance) {
            const currentZoom = mapInstance.getZoom() || 16;
            const newZoom = Math.min(currentZoom + 1, 18);
            mapInstance.setZoom(newZoom);
        }
    }, [mapInstance]);

    const handleZoomOut = useCallback(() => {
        if (mapInstance) {
            const currentZoom = mapInstance.getZoom() || 16;
            const newZoom = Math.max(currentZoom - 1, 6);
            mapInstance.setZoom(newZoom);
        }
    }, [mapInstance]);

    return (
        <ViewListingAboutLocationWrapper>
            <ViewListingAboutLocationTitle>
                {/* {listing.suburb}, {listing.state} */}
            You'll be staying in {listing.city}
            </ViewListingAboutLocationTitle>
            <ViewListingMapWrapper>
                <CloudMap
                    containerStyle={{
                        width: "100%",
                        height: "100%",
                        position: "absolute",
                        borderRadius: "12px",
                    }}
                    lat={lat}
                    lng={lng}
                    zoom={16}
                    minZoom={6}
                    maxZoom={18}
                    scrollWheelZoom={false}
                    gestureHandling="greedy"
                    zoomControl={false}
                    onMapLoad={handleMapLoad}
                />
                {isDesktop && mapInstance && (
                    <CustomZoomControls 
                        onZoomIn={handleZoomIn} 
                        onZoomOut={handleZoomOut} 
                />
                )}
                <MapPopupButton onClick={() => setIsMapPopupOpen(true)} />
            </ViewListingMapWrapper>
            <ViewListingAboutLocationSubtitle>
                {listing.suburb}, {listing.state}, Australia
            </ViewListingAboutLocationSubtitle>
            <ViewListingLocationVerification>
                <ViewListingLocationVerificationIcon>
                    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M10 18.3333C14.6024 18.3333 18.3334 14.6024 18.3334 10C18.3334 5.39763 14.6024 1.66667 10 1.66667C5.39765 1.66667 1.66669 5.39763 1.66669 10C1.66669 14.6024 5.39765 18.3333 10 18.3333Z" stroke="#737373" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 13.3333V10" stroke="#737373" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                        <path d="M10 6.66667H10.0083" stroke="#737373" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                </ViewListingLocationVerificationIcon>
                <span>This location has been verified by Anystay for accuracy.</span>
            </ViewListingLocationVerification>
            <ViewListingMapPopup
                isOpen={isMapPopupOpen}
                onClose={() => setIsMapPopupOpen(false)}
                lat={lat}
                lng={lng}
                listingTitle={listing.propertyTitle}
            />
        </ViewListingAboutLocationWrapper>
    );
}
